import {
  EXECUTION_LOG_FILTER_MESSAGES,
  ExecutionLogFiltersMessages,
} from "./execution-log-filters.messages";
import { TABLE_COLUMNS_MESSAGES, TableColumnsMessages } from "../tables/columns.messages";

export type ExecutionLogMessages = ExecutionLogFiltersMessages &
  TableColumnsMessages & {
    executionLogTitle: string;
    logId: string;
    logDateSent: string;
    logContact: string;
    logRecipient: string;
    logStatus: string;
    logError: string;
    noLogsFound: string;
  };

export const EXECUTION_LOG_MESSAGES: ExecutionLogMessages = {
  // Card Title
  executionLogTitle: "Log de execução",

  // Column Labels
  logId: "ID do Log",
  logDateSent: "Data/Hora de Execução",
  logContact: "Contato",
  logRecipient: "Quem Recebeu",
  logStatus: "Status",
  logError: "Erro",

  // Other Messages
  noLogsFound: "Nenhum log de exceção encontrado.",

  ...TABLE_COLUMNS_MESSAGES,
  ...EXECUTION_LOG_FILTER_MESSAGES,
};
